import type { JSX } from 'react';
import { useT } from '../i18n/index.js';
import { useFullscreen } from '../screens/lib/fullscreen.js';
import { Icon } from './Icon.js';

/**
 * One button, worn by three different rails — the shell's, the compound's and
 * the room's — so it looks native to each rather than bolted on.
 *
 * It renders nothing where the browser will not allow fullscreen, which is the
 * honest answer on an iPhone: a control that cannot work should not be there
 * to be pressed.
 */
export function FullscreenButton({
  className = 's-iconbtn',
  size = 22,
}: {
  className?: string;
  size?: number;
}): JSX.Element | null {
  const { supported, active, toggle } = useFullscreen();
  const t = useT();

  if (!supported) return null;

  const label = t(active ? 'ui.fullscreen.exit' : 'ui.fullscreen.enter');
  return (
    <button type="button" className={className} onClick={toggle} title={label} aria-pressed={active}>
      <Icon name={active ? 'collapse' : 'expand'} size={size} label={label} />
    </button>
  );
}
